import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MergeAcceptPopupComponent } from '../merge-accept-popup/merge-accept-popup.component';
import { ReviewDataService } from '../../services/raintree/Transmission/review-data.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonEngine } from '@angular/ssr';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { error } from 'console';
import { response } from 'express';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-merge-reject-popup',
  standalone: true,
  imports: [MatDialogModule, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './merge-reject-popup.component.html',
  styleUrl: './merge-reject-popup.component.scss',
})
export class MergeRejectPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private _reviewDataService: ReviewDataService,
    private dialogRef: MatDialogRef<MergeRejectPopupComponent>,
    private toaster: ToastrService,
    private route: ActivatedRoute
  ) {}
  comments = new FormControl('');
  rejectAll: boolean = false;
  ngOnInit(): void {}
  onReject() {
    this.rejectAll = true;
    if (this.comments?.value?.length == 0) {
      this.toaster.clear();
      this.toaster.error('Enter comments first');
    } else {
      const queryParams: any = { ...this.route.snapshot.queryParams };
      let reqBody = this.data.data.map(
        (obj: { isApproved: any; memberCode: any }) => {
          // if (obj.isApproved) {
          //   this.checkCount++;
          // }

          return {
            isApproved: false,
            memberCode: obj.memberCode,
          };
        }
      );
      reqBody = {
        reviewFCArr: [...reqBody],
        rejectReason: this.comments.value,
        uiState: queryParams['state'],
        uiDistrict: queryParams['district'],
      };
      console.log(reqBody, 'req body');

      this._reviewDataService
        .approveMergeData(this.data.memKey, reqBody)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            if (!response.error)
              this.dialog.open(DpSuccessMessageComponent, {
                data: {
                  mainHeading: 'Rejected data successfully',
                  subHeading:
                    'Please go back to review page to approve/reject more',
                  buttonValue: 'Finish',
                },
              });
            this.rejectAll = false;
            this.dialogRef.close(true);
          },
          error: (error) => {
            console.log(error);
            this.toaster.error(error);
          },
        });
    }
  }
  onApproveClick() {
    console.log(this.data, 'reject');
    this.data.data = this.data.data.map(
      ({ ['isApproved']: _, ...rest }: any) => rest
    );
    this.dialog.open(MergeAcceptPopupComponent, {
      data: { fc: this.data.data, memKey: this.data.memKey },
    });
    this.dialogRef.close();
  }
}
